(function ($) {
  $(document).ready(function ($) {
    /*****************************************************************
      Klaviyo form integration (/pages/signup)
    *****************************************************************/
    function KlaviyoSubscribePage(listID, name, email, source) {
      var subscribed = false;
      $.ajax({
        type: 'POST',
        url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
        data: {
          g: listID,
          $fields: 'name, $source, $consent, $email, Accepts Marketing',
          email: email,
          name: name,
          $consent: ['email'],
          //pass in additional fields
          //$fields: "$source, $first_name, $last_name",
          AcceptsMarketing: true,
          $source: source,
        },
        contentType: 'application/x-www-form-urlencoded',
        error: function (err) {
          console.log('Could not connect to Klaviyo.');
          console.log(err);
        },
        success: function (res) {
          console.log('success');
          console.log(res);
          subscribed = true;

          if (res.data.is_subscribed == false) {
            $('#page-klaviyo').remove();
            $('#page-klaviyo-message p').text(successMsg);
          }

          if (res.data.is_subscribed == true) {
            successMsg = 'That email is already subscribed to our list!';
            $('#page-klaviyo').remove();
            $('#page-klaviyo-message p').text(successMsg);
          }
        },
        async: false,
      });
      return subscribed;
    }

    $('#subscribe-page').click(function (event) {
      event.preventDefault();
      const listID = $('#page-klaviyo').data('klaviyoid');
      const name = $('#page-subscribe-name').val();
      const email = $('#page-subscribe').val();
      const source =
        'Nocsprovisions.com - General Newsletter, from Sign Up Page';
      console.log(listID, email, source);
      if (email != '') {
        KlaviyoSubscribePage(listID, name, email, source);
      } else {
        // do nothing
      }
    });
    /*****************************************************************
      END Klaviyo form integration
    *****************************************************************/
  });
})(jQuery);
